<template>
  <v-app-bar app clipped-left :height="48" class="main-app-bar">
    <v-app-bar-nav-icon @click.stop="drawerChange"></v-app-bar-nav-icon>
    <v-btn
      icon
      small
      class="hidden-xs-only mr-1 ml-1"
      v-if="!isHomeRoute"
      @click.prevent="backButtonClick"
    >
      <v-icon size="22">arrow_back</v-icon>
    </v-btn>
    <v-toolbar-title class="main-app-bar__title">{{
      this.currentRootTitle
    }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <template v-if="isProjectsRoute">
      <v-select
        v-model="sortBy"
        :items="sortOptions"
        dense
        flat
        hide-details
        solo-inverted
        prepend-inner-icon="mdi-sort"
        class="main-app-bar__sort mr-2"
      ></v-select>
      <v-btn
        icon
        small
        class="main-app-bar__sortdir mr-2"
        :title="sortDir === 'asc' ? 'Ascending' : 'Descending'"
        @click="toggleSortDir"
      >
        <v-icon size="20">{{
          sortDir === 'asc' ? 'mdi-sort-ascending' : 'mdi-sort-descending'
        }}</v-icon>
      </v-btn>
      <v-text-field
        v-model="searchQuery"
        dense
        flat
        hide-details
        clearable
        solo-inverted
        prepend-inner-icon="mdi-magnify"
        placeholder="Search projects"
        class="main-app-bar__search"
      ></v-text-field>
    </template>
  </v-app-bar>
</template>

<script>
export default {
  components: {},

  props: {
    source: String,
    drawer: Boolean
  },

  data: () => ({
    drawerLocal: null,
    sortOptions: [
      { text: 'Project ID', value: 'id' },
      { text: 'Name', value: 'name' }
    ]
  }),

  created() {
    this.$vuetify.theme.dark = true
  },

  methods: {
    backButtonClick: function(e) {
      let path = e.path || e.composedPath()
      path[1].blur()
      this.$router.go(-1)
    },
    drawerChange() {
      this.drawerLocal = !this.drawerLocal
      this.$emit('drawerChange', this.drawerLocal)
    },
    toggleSortDir() {
      this.$store.commit(
        'ProjectStore/SET_SORT_DIR',
        this.sortDir === 'asc' ? 'desc' : 'asc'
      )
    }
  },
  computed: {
    currentRootTitle() {
      return this.$route.name
    },
    isHomeRoute() {
      return this.$route.path === '/'
    },
    isProjectsRoute() {
      return this.$route.name === 'Projects'
    },
    searchQuery: {
      get() {
        return this.$store.state.ProjectStore.searchQuery
      },
      set(value) {
        this.$store.commit('ProjectStore/SET_SEARCH_QUERY', value || '')
      }
    },
    sortBy: {
      get() {
        return this.$store.state.ProjectStore.sortBy
      },
      set(value) {
        this.$store.commit('ProjectStore/SET_SORT_BY', value)
      }
    },
    sortDir() {
      return this.$store.state.ProjectStore.sortDir
    }
  },
  watch: {
    drawer: function(newValue) {
      this.drawerLocal = newValue
    }
  }
}
</script>

<style scoped>
.main-app-bar__title {
  font-size: 17px;
}
.main-app-bar__search {
  max-width: 240px;
}
.main-app-bar__sort {
  max-width: 160px;
}
/* Keep the solo fields comfortably inside the shorter app bar */
.main-app-bar__search >>> .v-input__slot,
.main-app-bar__sort >>> .v-input__slot {
  min-height: 34px !important;
}
.main-app-bar__search >>> .v-input__prepend-inner,
.main-app-bar__sort >>> .v-input__prepend-inner {
  margin-top: 6px !important;
}
.main-app-bar__sort >>> .v-input__append-inner {
  margin-top: 6px !important;
}
</style>
